import {
	type Action,
	createActionsHook,
	createHook,
	createSelector,
	createStore,
} from 'react-sweet-state';

type SpotlightState = {
	spotlight:
		| {
				state: 'hidden';
		  }
		| {
				state: 'visible';
				activeSpotlight: number;
		  }
		| {
				state: 'seen';
		  }
		| {
				state: 'dismiss';
		  };
};

const initialState: SpotlightState = {
	spotlight: { state: 'hidden' },
};

const actions = {
	start:
		(): Action<SpotlightState> =>
		({ getState, setState }) => {
			const { spotlight } = getState();
			if (spotlight.state !== 'hidden') {
				return;
			}

			setState({ spotlight: { state: 'visible', activeSpotlight: 0 } });
		},
	next:
		(): Action<SpotlightState> =>
		({ setState, getState }) => {
			const { spotlight } = getState();
			if (spotlight.state !== 'visible') {
				return;
			}

			setState({ spotlight: { state: 'visible', activeSpotlight: spotlight.activeSpotlight + 1 } });
		},
	end:
		(): Action<SpotlightState> =>
		({ setState }) => {
			setState({ spotlight: { state: 'seen' } });
		},
	dismiss:
		(): Action<SpotlightState> =>
		({ setState }) => {
			setState({ spotlight: { state: 'dismiss' } });
		},
};

const SpotlightStore = createStore({
	initialState,
	actions,
	name: 'SpotlightStore',
});

export const useSpotlightActions = createActionsHook(SpotlightStore);

export const useSpotlightStore = createHook(SpotlightStore);

export const useSpotlightState = createHook(SpotlightStore, {
	selector: createSelector(
		(state) => state.spotlight,
		(spotlightState) => spotlightState,
	),
});
